import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    TabNavigationCtrlFilterPanel: {
        margin: theme.sizes.spacing.default,
    },
    navigation: {
        display: 'flex',
        borderBottom: '2px #ccc solid',
        marginBottom: '7px',
        marginTop: theme.sizes.spacing.default,
    },
    containers: {
        minHeight: "528px",
    },
    headers: {
        display: 'flex',
        justifyContent: 'space-between',
        paddingBottom: theme.sizes.spacing.default,
        paddingTop: theme.sizes.spacing.default,

        [theme.breakpoints.down("md")]: {
            '& > h4': {
                fontSize: '14px',
                '& > span': {
                    display: 'block',
                    fontWeight: 'bold',
                    '&.schudulingNumber': {
                        textAlign: 'right',
                    }
                }
            }
        }
    },
    navigationRoutes: {
        flex: 1,
    },
    navigationRoutesTabs: {
        width: '100%',
        [theme.breakpoints.down("md")]: {
          paddingTop: '60px',
        },
    },
    navigationRoutesTabsTab: {
        paddingTop: theme.sizes.spacing.minor,
        paddingBottom: theme.sizes.spacing.minor,
        fontWeight: 'bold',
        fontSize: '1rem',
    },
    navigationControls: {
        textAlign: 'right',
        position: 'relative',
        [theme.breakpoints.down("md")]: {
            textAlign: 'center',
        }
    },
    addButton: {
        boxShadow: "0 0 0",
        fontSize: "1.2rem",
        borderRadius: 0,
        maxWidth: '300px',
        height: '65px',
        width: "100%",
        marginLeft: theme.sizes.spacing.minor,
        [theme.breakpoints.down("md")]: {
            marginLeft: '0',
            marginBottom: '10px',
        }
    },
    cancelButton: {
        boxShadow: "0 0 0",
        fontSize: "1.2rem",
        borderRadius: 0,
        backgroundColor: '#999999',
        maxWidth: '300px',
        height: '65px',
        width: "100%",
        marginLeft: theme.sizes.spacing.minor,
        [theme.breakpoints.down("md")]: {
            marginLeft: 0,
        },
    },
    containerButtons: {
      position: 'absolute',
      top: '-115px',
      right: '0',
      width: '100%',
      [theme.breakpoints.down("md")]: {
        marginLeft: 0,
        textAlign: 'left',
        top: '-170px',
      },
    },
    downloadButton: {
      boxShadow: "0 0 0",
      fontSize: "1.2rem",
      borderRadius: 0,
      maxWidth: "150px",
      height: "65px",
      width: "100%",
      position: 'relative',
      marginRight: theme.sizes.spacing.minor,
      [theme.breakpoints.down("md")]: {
        marginLeft: 0,
      },
    },
    backButton: {
        boxShadow: "0 0 0",
        fontSize: "1.2rem",
        borderRadius: 0,
        maxWidth: '200px',
        height: '65px',
        width: "100%",
        position: 'relative',
        [theme.breakpoints.down("md")]: {
          width: '100px',
        }
    },
    gridDouble: {
        '& > .MuiGrid-container > .MuiGrid-item:last-child': {
            paddingLeft: '22px',
        },
        [theme.breakpoints.down("md")]: {
            '& > .MuiGrid-container > .MuiGrid-item:last-child': {
                paddingLeft: '0',
            },
        },
    },
    controls: {
        textAlign: 'right',
        paddingTop: '40px',
        [theme.breakpoints.down("md")]: {
            textAlign: 'left',
            paddingTop: '16px',
        },
    },
    inputRDS: {
        backgroundColor: 'white',
        '& .MuiInputLabel-shrink': {
            color: 'white',
            transform: 'translate(14px, -16px) scale(0.75)',
        }
    },
    noContent: {
        textAlign: 'center',
        '& > .MuiButton-root': {
            borderRadius: 0,
            height: 37,
            minWidth: '200px',
        }
    },
    fileLink: {
        color: 'black',
        textDecorator: 'underline',
        '& > .MuiButton-root': {
            borderRadius: 0,
            height: 37,
            marginLeft: 10,
        },
        [theme.breakpoints.down("md")]: {
            display: 'flex',
            '& > span': {
                flex: 1,
                overflow: 'hidden',
                fontSize: '12px',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
            },
            '& > .MuiButton-root': {
                marginTop: '-15px',
            },
        },
    }
}));

export default useStyles;
